import React, { AnchorHTMLAttributes, forwardRef } from 'react';

import PropTypes from 'prop-types';

import theme, {
  stylePropType,
  StylableComponent,
} from '@adsk/alloy-react-theme';

const A = forwardRef<
  HTMLAnchorElement,
  StylableComponent<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>
>(({ style, className, children, href, target, onClick, ...props }, ref) => (
  <a
    rel="noopener noreferrer"
    role="link"
    {...props}
    ref={ref}
    href={href}
    target={target}
    className={className}
    onClick={onClick}
    css={[
      {
        color: theme.tokens.colors.text.link.value,
        textDecoration: 'none',
        '&:hover': {
          color: theme.tokens.colors.text.hover.value,
        },
        '&:active': {
          color: theme.tokens.colors.text.pressed.value,
        },
      },

      style,
    ]}
  >
    {children}
  </a>
));

A.displayName = 'A';

A.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  The component's children */
  children: PropTypes.any,
  /**  href is url string a linked to */
  href: PropTypes.string.isRequired,
  /**  a href target */
  target: PropTypes.string,
  /**  anchor onClick event handler */
  onClick: PropTypes.func,
};

export default A;
